<button rds-fab-button size="l" (click)="popover.toggle()" #popover="rdsPopover" rdsPopoverPosition="right-center"
        rdsPopoverClass="roles-helper-popover" [rdsPopover]="popoverTemplate">
  <rds-icon rdsTooltip="Open Freeze Dialog" icon="stop" namespace="outlined"></rds-icon>
</button>

<ng-template #popoverTemplate>
  <rds-popover-text-content style="width: 400px; display: block;">
    <div rds-popover-header>
      Set blocked adding content to RocheHome and NewsBoard. <br/>
    </div>
    <div rds-popover-paragraph [formGroup]="form">
      <div class="row">
        <div class="col mb-5">
          This will not affect API, but UI will be blocked for adding content. <br/> You can unblock it by unchecking.
        </div>
      </div>
      <div class="row">
        <div class="col mb-5">
          <rds-switch formControlName="blocked" labelPosition="before" size="m">
            <rds-icon icon="user" namespace="outlined" class="c-600-roche-blue"></rds-icon>
            Set blocked
          </rds-switch>
        </div>
        <div class="col mb-5">
          <rds-switch formControlName="userHasWriteAccessPermission" labelPosition="before" size="m">
            <rds-icon icon="user" namespace="outlined" class="c-600-roche-blue"></rds-icon>
            Set user can edit
          </rds-switch>
        </div>
      </div>
      <rds-divider></rds-divider>
      <div class="row">
        <div class="col-12 mb-3">
          <div>
            <div class="col mb-5">
              Hide newsletter blocks (if blocked):
            </div>
            <div *ngFor="let blockType of blockList">
              <rds-switch
                [checked]="hiddenBlocks?.includes(blockType)"
                (buttonChanged)="onToggleBlockType(blockType, hiddenBlocks)"
                size="m"
                labelPosition="after">
                {{ blockType }}
              </rds-switch>
            </div>
          </div>
        </div>
      </div>
      <rds-divider></rds-divider>
      <div class="row">
        <div class="col-12 mb-3">
          <div>
            <div class="col mb-5">
              <rds-switch formControlName="sendingNewslettersOnBehalfOfUsers" labelPosition="before" size="m">
                <rds-icon icon="user" namespace="outlined" class="c-600-roche-blue"></rds-icon>
                Allow to send newsletter on behalf
              </rds-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </rds-popover-text-content>
</ng-template>
